/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.SET_STATION_ACTIVITY_OFFSET]: (state, payload) => {
    state.offset = payload;
  },

  [types.SET_STATION_ACTIVITY_REGION]: (state, payload) => {
    state.region = payload;
  },

  [types.SET_STATION_ACTIVITY_START_DATE]: (state, payload) => {
    state.startDate = payload;
  },

  [types.SET_STATION_ACTIVITY_END_DATE]: (state, payload) => {
    state.endDate = payload;
  },

  [types.GET_STATION_ACTIVITY]: state => {
    state.loadingStationActivity = true;
    state.loadingStationActivityFailed = false;
  },

  [types.GET_STATION_ACTIVITY_FAILURE]: (state, error) => {
    state.loadingStationActivity = false;
    state.loadingStationActivityFailed = true;
    state.loadingStationActivityError = error;
  },

  [types.GET_STATION_ACTIVITY_SUCCESS]: (state, response) => {
    state.loadingStationActivity = false;
    state.stationActivityData = response.data;
    state.loadingStationActivityFailed = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/stationactivity/mutations.js